<template>
  <div class="container">
    <img class="bg-img" src="~@static/ugc/list/bg.jpg">
    <img src="~@static/ugc/creation/txt.png" class="txt">
    <div class="checkbox-label-s2 protocal-txt">
      <div :class="isProtocolAccepted ? 'checkbox active' : 'checkbox'" @click="protocolToggle"></div>
      <div class="text">我已阅读并同意<router-link to="/scene/uploadterms" class="link-s2">上传须知</router-link>
      </div>
    </div>
    <div class="pink-circle-btn with-icon" @click="bindToBegin">
      <div class="btn-inner">
        <div class="text">知道啦</div>
        <img src="~@static/icon-pink-circle-btn.png">
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { verify, tools } from '@/utils'
import { behavior } from '@/utils/behavior'
export default {
  data() {
    return {
      hasAuthorization: false,
      isProtocolAccepted: false,
    }
  },
  computed: {
    ...mapState(['authorization']),
  },
  components: {},
  created(opts) {},
  mounted() {
    if (!this.authorization || this.authorization == '') {
      this.hasAuthorization = true
    } else {
      this.hasAuthorization = false
    }

    if (verify.isWeixin()) {
      let shareInfo = {
        title: '绝对夜计划',
        desc: '绝对赛博夜计划，最高赢取5万元派对金，邀你一起造',
        imgUrl: this.$apiConfig.domain + '/static/funding_cpunk/share.png?v=1',
      }
      let p = tools.parseParams(this.$route.query)
      this.WXConfig.wxShowMenu(`${this.$apiConfig.domain}/welcome?${p}`, shareInfo)
    }
  },
  methods: {
    protocolToggle() {
      this.isProtocolAccepted = !this.isProtocolAccepted
    },
    bindToBegin() {
      if (!this.isProtocolAccepted) {
        alert('请阅读并同意上传须知')
        return
      }
      if (!this.authorization || this.authorization == '') {
        alert('您还未登录，需要登录后可获得完整体验')
        this.$router.push(`/login?redirect=${encodeURIComponent('/scene/create')}`)
      } else {
        _jcq.push(['_track', 'ugc_knowclick'])
        behavior({ behavior_code: 'prc_bhv_abs_pw_bc8' })
        this.$router.push('/scene/create')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '@styles/v2-common.scss';
@import '@styles/ugc/ugc.scss';
.container {
  font-family: 'SourceHanSansCN-Normal';
  overflow: hidden;
}
.bg-img {
  position: fixed;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.txt {
  width: (549/7.5) * 1vw;
  height: auto;
  margin: (80/7.5) * 1vw auto (70/7.5) * 1vw;
  display: block;
}
.part {
  padding: (80/7.5) * 1vw 0 (50/7.5) * 1vw;
  margin: 0 auto;
  text-align: center;
}
.part2 {
  padding: 0;
}
.part3 {
  padding: 0 0 (40/7.5) * 1vw;
}
.title {
  font-size: (55/7.5) * 1vw;
  text-align: center;
  position: relative;
  display: inline;
}
.title::before {
  content: '';
  width: 120%;
  height: (20/7.5) * 1vw;
  background: linear-gradient(to right, #dc2dbf, #2f32a7);
  position: absolute;
  bottom: -(2/7.5) * 1vw;
  left: 50%;
  transform: translate(-50%);
  border-radius: (10/7.5) * 1vw;
  z-index: -1;
}
.protocal-txt {
  display: flex;
  align-items: center;
  width: 76.8vw;
  height: pxtow(48);
  margin: pxtow(20) auto;
}
</style>



// WEBPACK FOOTER //
// src/pages/ugc/intro.vue